import React from "react";
import { defineMessages } from "react-intl";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import { ButtonGroup } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { IconButton, Button, SquareIconButton } from "./Buttons.js";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useClasses = makeStyles()((theme) => ({
  placement: {
    alignSelf: "flex-start"
  },
  editModalButton: {
    height: theme.spacing(4)
  }
}));
const localized = defineMessages({
  editModalButtonNextLabel: {
    id: "EditModalButton_editModalButtonNextLabel",
    defaultMessage: "Next"
  }
});
const EditButton = ({
  mode = "Read",
  disabled = false,
  disabledSubmitButton,
  onEdit,
  onCancel,
  onSave,
  onNextStep
}) => {
  const { classes } = useClasses();
  switch (mode) {
    case "Read":
      return /* @__PURE__ */ React.createElement(
        IconButton,
        {
          iconClassName: `${CustomIcon.WriteOutline}`,
          onClick: onEdit,
          "data-testid": "editButton",
          size: "small",
          disabled
        }
      );
    case "Edit": {
      return /* @__PURE__ */ React.createElement(ButtonGroup, { "aria-label": "outlined primary button group", className: classes.placement }, /* @__PURE__ */ React.createElement(
        SquareIconButton,
        {
          type: "submit",
          iconClassName: CustomIcon.Confirm,
          size: "small",
          "data-testid": "submitButton",
          onSubmit: onSave,
          disabled: disabled || disabledSubmitButton
        },
        /* @__PURE__ */ React.createElement(DoneIcon, null)
      ), /* @__PURE__ */ React.createElement(
        SquareIconButton,
        {
          iconClassName: CustomIcon.CancelOutline,
          type: "button",
          size: "small",
          onClick: onCancel,
          "data-testid": "stopEditButton",
          disabled
        },
        /* @__PURE__ */ React.createElement(ClearIcon, null)
      ));
    }
    case "EditMultiStep": {
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          className: classes.editModalButton,
          color: "primary",
          size: "small",
          label: localized.editModalButtonNextLabel,
          onClick: onNextStep,
          disabled
        }
      );
    }
    case "InProgress":
      return /* @__PURE__ */ React.createElement(IconButton, { iconClassName: CustomIcon.Union, size: "small", disabled: true, className: classes.placement });
    default:
      return null;
  }
};
export {
  EditButton
};
//# sourceMappingURL=EditButton.js.map
